import { call, put, select } from 'redux-saga/effects';

import { callAPI, METHODS } from '../../api';
import { RESOURCES } from '../../../../helpers/constants';
import { setBannerAPIRequestState } from '../../../effects/message';
import { setProfile } from '../../../effects/organization';

export default function* updateProfile({ payload }) {
  const { dpaApiBaseUrl } = yield select((state) => state.application.env);
  const url = `${dpaApiBaseUrl + RESOURCES.V3}/users/me`;
  const { success, error, result } = yield call(callAPI, {
    url,
    method: METHODS.PUT,
    body: payload,
  });
  if (!error && success) {
    if (result.uuid) {
      result.userId = result.uuid;
    }
    yield put(setProfile({ ...result }));
    yield put(
      setBannerAPIRequestState({
        bannerState: 'success',
        bannerMessage: 'Your profile has been successfully updated!',
      }),
    );
  } else {
    console.error(error);
    yield put(
      setBannerAPIRequestState({
        bannerState: 'error',
        bannerMessage: 'Something went wrong while updating your profile...',
      }),
    );
  }
}
